import { render } from "./AuditProductModal.vue?vue&type=template&id=db7f432a"
import script from "./AuditProductModal.vue?vue&type=script&lang=js"
export * from "./AuditProductModal.vue?vue&type=script&lang=js"
script.render = render

export default script